import { registerModels as reg } from 'spa-ionata-admin/lib/models';
import Sector from './Sector';
import Category from './Category';
import Business from './Business';
import Post from './Post';
import EoiLead from './EoiLead';
import BusinessLead from './BusinessLead';
import DraftBusiness from './DraftBusiness';
import SiteLayout from './SiteLayout';
import ExportMarket from './ExportMarket';
import TradeMission from './TradeMission';
import Award from './Award';

export function registerModels() {
  return reg([
    Business,
    DraftBusiness,
    Sector,
    Category,
    Post,
    BusinessLead,
    EoiLead,
    SiteLayout,
    ExportMarket,
    TradeMission,
    Award,
  ]);
}
